import '../scss/dynform.scss';
var J = jQuery, Jd = J(document), percent = J('input[name="dynform_tax_percent"]').length ? J('input[name="dynform_tax_percent"]').val() : 75;

Jd.ready(function(){

    let sumValue = false;
    if (J('input[name="dynform_sum_value"]').val() != '') {
        sumValue = J('input[name="dynform_sum_value"]').val();
    }
    changePeriodValue();
    changeSumValue(sumValue);
    dynformSumValue(sumValue);

    Jd.off('change', 'input[name="dynform_period"]').on('change', 'input[name="dynform_period"]', function(){
        changePeriodValue(J(this).attr('data-value'));
        J('.flex-period-item').removeClass('flex-period-item-selected')
        J(this).parent().parent().addClass('flex-period-item-selected')
    });

    Jd.off('change', 'input[name="dynform_sum"]').on('change', 'input[name="dynform_sum"]', function(){
        changeSumValue(J(this).val());
        J('.flex-sum-item').removeClass('flex-sum-item-selected')
        J(this).parent().parent().addClass('flex-sum-item-selected')
    })

    Jd.off('change', 'input[name="dynform_sum_value"]').on('change', 'input[name="dynform_sum_value"]', function(){
        dynformSumValue(J(this).val());
    });

    Jd.off('change', 'input[name="dynform_society"]').on('change', 'input[name="dynform_society"]', function(){
        if (J(this).prop('checked')) {
            J('.dynform-society-name').fadeIn(300);
        } else {
            J('.dynform-society-name').fadeOut(300);
        }
    });

    Jd.off('click', '.dynform-modal-close').on('click', '.dynform-modal-close', function(){
        J('.dynform-modal').fadeOut(300);
        return;
    });
});


function changePeriodValue(periodDataValue=false) {
    if (!periodDataValue) periodDataValue = J('input[name="dynform_period"]:checked').attr('data-value');
    J('span#dynform_period_value').text(periodDataValue)
}

function changeSumValue(sumValue=false) {
    if (!sumValue) sumValue = J('input[name="dynform_sum"]:checked').val();
    J('input[name="dynform_sum_value"]').val(sumValue).trigger('change');
}


function dynformSumValue(sumValue) {
    if (!sumValue) sumValue = J('input[name="dynform_sum"]:checked').val();
    var sumAfterTax = (sumValue -(sumValue*percent/100)).toFixed(2);
        sumAfterTax = sumAfterTax.replace('.', ',');
    J('.total-item-after-tax').find('span.sum').text(sumAfterTax+'€');
    J('input[name="dynform_sum_value_after_tax"]').val(sumAfterTax)
    J('input[name="dynform_tax_percent"]').val(percent);
}